var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hour-block__container",style:({
        'min-height': _vm.periods.pixelBasePerMinute * _vm.calendarRefs.hour + 'px',
        'max-height': _vm.periods.pixelBasePerMinute * _vm.calendarRefs.hour + 'px'
    })},[_c('span',{staticClass:"hour-block__label"},[_vm._v(" "+_vm._s(_vm.label)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }